import React from 'react';
import MTemplate from './MTemplate';
import "./_Template.scss"
export default function Template() {
  return <MTemplate />;
}
